module.exports = __webpack_public_path__ + "static/media/elements_fallrisk.2b6a2359.png";